import { useEffect, useState } from 'react';
import { Store, Sparkles } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Promotional banner nudging customers to choose pickup over delivery.
 * Pulls the pickup discount % from /api/settings (fallback 10).
 * `compact=true` → smaller variant suitable for the cart drawer.
 */
const PickupDiscountBanner = ({ compact = false }) => {
  const [pct, setPct] = useState(10);

  useEffect(() => {
    let mounted = true;
    axios.get(`${API}/settings`).then(r => {
      if (mounted && r.data?.pickup_discount_percentage) {
        setPct(r.data.pickup_discount_percentage);
      }
    }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  if (pct <= 0) return null;

  if (compact) {
    return (
      <div
        className="flex items-center gap-2 rounded-xl px-3 py-2 bg-gradient-to-r from-[#2C5E3E] to-[#1D4A2E] text-white shadow-sm"
        data-testid="pickup-discount-banner-compact"
      >
        <Store className="w-4 h-4 shrink-0" />
        <p className="font-sans text-xs leading-tight">
          <strong>Recoge en tienda</strong> y ahorra <strong>{pct.toFixed(0)}%</strong> en tu pedido
        </p>
      </div>
    );
  }

  return (
    <div
      className="relative overflow-hidden rounded-2xl px-5 py-4 bg-gradient-to-r from-[#2C5E3E] via-[#3A7A52] to-[#E28743] text-white shadow-md max-w-3xl mx-auto mb-6"
      data-testid="pickup-discount-banner"
      role="region"
      aria-label="Oferta de recogida"
    >
      <div className="absolute -right-6 -top-6 w-24 h-24 rounded-full bg-white/10 pointer-events-none" />
      <div className="absolute -left-8 -bottom-8 w-28 h-28 rounded-full bg-white/5 pointer-events-none" />
      <div className="relative flex items-center gap-3 sm:gap-4">
        <div className="shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white/15 backdrop-blur flex items-center justify-center">
          <Store className="w-5 h-5 sm:w-6 sm:h-6" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-serif text-base sm:text-lg font-bold flex items-center gap-2 leading-tight">
            <Sparkles className="w-4 h-4 text-[#FFE066]" aria-hidden="true" />
            Recoge en tienda y ahorra <span className="text-[#FFE066]">{pct.toFixed(0)}%</span> en tu pedido
          </p>
          <p className="font-sans text-xs sm:text-sm text-white/85 mt-0.5">
            Sin envio, sin pedido minimo. El descuento se aplica automaticamente al elegir Recogida.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PickupDiscountBanner;
